/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_5_4Inputs */



/**
* | output |
* | --- |
* | "Regular evaluation of audit logs" |
*
* @param {Guardrails_Section_5_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_5_4 = /** @type {((inputs?: Guardrails_Section_5_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_5_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regelmäßige Auswertung der Audit-Logs")
	return /** @type {LocalizedString} */ ("Regular evaluation of audit logs")
});